import { StringService } from '../../services';

export interface MultiLinkData {
  anchor: string;
  cached_url: string;
  story: {
    url: string;
  }
  id: string;
  linktype?: string;
  url?: string;
  fieldtype?: string;
}

const rootAlias = 'home';

const parseExternalUrl = (url: string): string => {
  if (!url) return '';
  return url.startsWith('www') ? `https://${url}` : url;
};

const parseInternalUrl = ({ url, anchor }): string => {
  if (!url) return '';
  return `/${url.replace(rootAlias, '')}${anchor ? `#${anchor}` : ''}`.replace('//', '/');
};

export const multiLink = (key: string, data: MultiLinkData): Record<string, string> => {
  const {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    cached_url, anchor, url, story,
  } = data;
  const multiLinkUrl = story?.url ?? url;
  const parsedLink = parseExternalUrl(url) || parseInternalUrl({ url: multiLinkUrl, anchor });
  return ({ [StringService.snakeToKebab(key)]: parsedLink });
};
